/**
 * Module dependencies.
 */

import React from 'react';
import { Card } from '@tremor/react';
import { Title } from 'app/components/atoms/title/title';
import { useTranslation } from 'react-i18next';

/**
 * Export `DeveloperOverview` component.
 */

export function DeveloperOverview(): JSX.Element {
  const [translate] = useTranslation();

  return (
    <Card>
      <Title>{translate('developer.overview.title')}</Title>
    </Card>
  );
}
